import { api } from './client.js';

/**
 * 화면별 사용자 설정 (예: 표에서 어떤 컬럼을 보여줄지). 브라우저 로컬 저장이
 * 아니라 DB 에 저장돼, 다른 PC 에서 열어도 같은 구성이 보인다.
 */
export const prefsApi = {
  get: <T = unknown>(screenId: string) =>
    api.get<{ pref: T | null }>(`/prefs/${encodeURIComponent(screenId)}`),

  save: (screenId: string, pref: Record<string, unknown>) =>
    api.put<{ ok: true }>(`/prefs/${encodeURIComponent(screenId)}`, { pref }),
};
